import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import { DASHBOARD_MENU_ROUTE_BY_TITLE } from '../lib/routes';

const QUICK_ACCESS_ROUTES = {
  'تجارت': '/trade',
  'حمل و نقل': '/transport',
  'سرمایه‌گذاری': '/investment'
};

const normalizeFa = (value = '') =>
  String(value)
    .trim()
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, '')
    .toLowerCase();

const DASHBOARD_MENU_ROUTE_BY_TITLE_NORMALIZED = Object.entries(DASHBOARD_MENU_ROUTE_BY_TITLE).reduce(
  (acc, [title, route]) => {
    acc[normalizeFa(title)] = route;
    return acc;
  },
  {}
);

function findQuickAccessAside() {
  const headings = Array.from(document.querySelectorAll('h4'));
  const headingEl = headings.find(
    (h) => (h.textContent || '').trim() === 'دسترسی سریع و آسان'
  );
  return headingEl?.closest?.('aside') || null;
}

function isQuickAccessCardElement(el) {
  if (!(el instanceof Element)) return false;
  return (
    el.tagName === 'DIV' &&
    el.classList?.contains?.('rounded-[2rem]') &&
    el.classList?.contains?.('cursor-pointer')
  );
}

function getQuickAccessRouteFromClickTarget(target, quickAccessAside) {
  if (!(target instanceof Element)) return null;
  if (!(quickAccessAside instanceof Element)) return null;
  if (!quickAccessAside.contains(target)) return null;

  let el = target;
  for (let i = 0; i < 18 && el && el !== quickAccessAside; i += 1) {
    if (isQuickAccessCardElement(el)) {
      const h5 = el.querySelector?.('h5');
      const title = (h5?.textContent || '').trim();
      return QUICK_ACCESS_ROUTES[title] || null;
    }

    el = el.parentElement;
  }

  return null;
}

function getDashboardMenuRouteFromClickTarget(target) {
  if (!(target instanceof Element)) return null;

  const el = target.closest?.('[data-route-title]');
  if (!el) return null;

  const rawTitle = el.getAttribute?.('data-route-title') || '';
  const title = normalizeFa(rawTitle);
  return DASHBOARD_MENU_ROUTE_BY_TITLE_NORMALIZED[title] || null;
}

export default function DashboardRouter() {
  const navigate = useNavigate();

  useEffect(() => {
    const onClick = (e) => {
      if (!(e.target instanceof Element)) return;

      if (window.getSelection?.()?.toString?.()) return;

      const quickAccessAside = findQuickAccessAside();
      if (quickAccessAside && quickAccessAside.contains(e.target)) {
        const route = getQuickAccessRouteFromClickTarget(e.target, quickAccessAside);
        if (route) navigate(route);
        return;
      }

      const menuRoute = getDashboardMenuRouteFromClickTarget(e.target);
      if (menuRoute) navigate(menuRoute);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate]);

  return <Dashboard />;
}

